export const registerNotificationEvents = (
  socket,
  { onNewNotification, onUnreadCount }
) => {
  if (!socket) return;

  socket.on("new_notification", (payload) => {
    onNewNotification(payload);
  });
};
